module.exports = __webpack_public_path__ + "img/Flag_of_Burundi.727efc31.svg";